/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Step_TokenInputs */

const en_directory_agents_step_token = /** @type {(inputs: Directory_Agents_Step_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receives a project-scoped token (sk_proj_) after your approval.`)
};

const zh_directory_agents_step_token = /** @type {(inputs: Directory_Agents_Step_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的批准后获得仅限该项目的令牌（sk_proj_）。`)
};

/**
* | output |
* | --- |
* | "Receives a project-scoped token (sk_proj_) after your approval." |
*
* @param {Directory_Agents_Step_TokenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_step_token = /** @type {((inputs?: Directory_Agents_Step_TokenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Step_TokenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_step_token(inputs)
	return zh_directory_agents_step_token(inputs)
});
export { directory_agents_step_token as "directory.agents.step_token" }